import { createTheme } from "@mui/material/styles";

export const COLORS = {
  blue: "#246DB6",
  darkBlue: "#1E4F9F",
  white: "#FFFFFF",
  black: "#000000",
  lightBlue: "#65BCEB",
  blue1: "#3387c5",
  yellow: "#FAE004"
};

const fontFamily = "'ATGText-Regular'";

const defaultTheme = createTheme();

const palette = {
  primary: {
    main: COLORS.blue,
  },
  secondary: {
    main: COLORS.lightBlue,
  },
  error: {
    main: COLORS.darkBlue,
  },
  warning: {
    main: COLORS.lightBlue,
  },
  info: {
    main: COLORS.darkBlue,
  },
  success: {
    main: COLORS.darkBlue,
  },
  text: {
    primary: COLORS.blue,
    secondary: COLORS.white,
    disabled: COLORS.darkBlue,
  },
};

const typography = {
  h1: {
    fontFamily,
    fontSize: "42px",
    [defaultTheme.breakpoints.down("lg")]: {
      fontSize: "42px",
    },
  },
  h2: {
    fontFamily: "'ATGRubrik'",
    fontSize: "36px",
    fontWeight: "normal !important",
    textTransform: 'uppercase',
    letterSpacing: "0.02em",
    [defaultTheme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  h3: {
    fontFamily: "'ATGRubrik'",
    fontSize: "36px",
    fontWeight: "normal !important",
    textTransform: 'uppercase',
    letterSpacing: "0.02em",
    [defaultTheme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  h4: {
    fontFamily,
    fontSize: "18px",
    [defaultTheme.breakpoints.down("lg")]: {
      fontSize: "16px",
    },
  },
  h5: {
    fontFamily: "'ATGRubrik'",
    fontSize: "16px",
    fontWeight: "normal !important",
    lineHeight: 1,
    [defaultTheme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  h6: {
    fontFamily,
    fontWeight: "normal !important",
    fontSize: "20px",
    marginTop: "25px",
    marginBottom: "16px",
    [defaultTheme.breakpoints.down("lg")]: {
      fontSize: "14px",
      marginTop: "24px",
      marginBottom: "16px",
    },
  },
  subtitle1: { fontFamily },
  subtitle2: { fontFamily },
  body1: { fontFamily, lineHeight: "21px" },
  body2: { fontFamily },
  caption: { fontFamily },
  button: { fontFamily },
  overline: { fontFamily },
};

const theme = createTheme({
  colors: COLORS,
  palette,
  typography,
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          fontFamily,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily,
          fontSize: "16px",
          lineHeight: "24px",
          borderRadius: "100px",
          padding: "16px 24px",
          backgroundImage: "linear-gradient(to bottom, #1C4897 0%,#1E54A0 50%, #2162AD 100%)",
          "&:hover": {
            filter: 'brightness(1) !important'
          }
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          fontFamily,
          flex: 1,
          width: "100%",
          height: "100%",
          padding: "0px !important",
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily,
          top: 6,
          "&.Mui-focused": {
            top: 6,
            color: COLORS.white,
            fontSize: "7px",
          },
          "&.MuiInputLabel-filled": {
            top: 6,
            color: COLORS.white,
            fontSize: "12px",
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        underline: {
          '&:after': {
            borderBottom: `2px solid ${COLORS.lightBlue}`,
          },
          '&:hover:not(.Mui-disabled)::after': {
            borderBottom: `2px solid ${COLORS.lightBlue}`,
          },
        },
      },
    },
    MuiInputBase: {
        styleOverrides: {
          root: {
              borderBottom: `2px solid ${COLORS.lightBlue}`,
          },
          input: {
            background: COLORS.blue,
            borderTopLeftRadius: '5px',
            borderTopRightRadius: '5px',
            color: COLORS.white,

            '&.Mui-focused': {
                borderColor: COLORS.white
            },
          }
        }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: COLORS.white,
          maxHeight: '30px'
        },
        label: {
          fontSize: 20,
          [defaultTheme.breakpoints.down("sm")]: {
            fontSize: 14,
          },
        }
      }
    },
    // MuiTypography: {
    //   styleOverrides: {
    //     root: {
    //       fontFamily,
    //     },
    //   },
    // },
    MuiSlider: {
      styleOverrides: {
        thumb:{
          color: COLORS.yellow
        },
        track: {
          color: COLORS.yellow
        },
        markLabel: {
          fontSize: '12px',
          color: COLORS.white
        },
        markLabelActive: {
          color: COLORS.white
        }
      }
    }
  },
});

export default theme;
